<template>
  <div
    v-if="paymentGateway.methods.giftCard && giftCards.length > 0"
    class="cf-flex cf-flex--column cf-flex--gap-12"
  >
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between">
      <h3 class="cf-title cf-title--3">
        Gift Cards
      </h3>

      <button
        class="cf-button cf-button--secondary cf-button--fixed-32"
        type="button"
        title="Add Gift Card"
        :disabled="!canApplyGiftCards"
        @click="addNewGiftCardClickHandler"
      >
        <span class="cf-icon far fa-plus" />
      </button>
    </div>

    <div class="cf-flex cf-flex--column cf-flex--gap-10">
      <label
        v-for="card in giftCards"
        :key="card.cardNumber"
        :class="['cf-card cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-space-between', { 'cf-card--disabled': !card.isApplied && !canApplyGiftCards }]"
        :for="`selectedGiftCard${card.cardNumber}`"
      >
        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8">
          <div class="cf-checkbox-input cf-checkbox-input--default cf-checkbox-input--no-label-text">
            <div class="cf-checkbox-input__option">
              <input
                :id="`selectedGiftCard${card.cardNumber}`"
                class="cf-checkbox-input__input"
                type="checkbox"
                name="selectedGiftCard"
                :disabled="!card.isApplied && !canApplyGiftCards"
                :checked="card.isApplied"
                @input="inputHandler(card)"
              >

              <div class="cf-checkbox-input__label" />
            </div>
          </div>

          <cf-card-type-icon
            payment-type="GiftCard"
            :card-design-url="card.design.url"
          />

          <h4 class="cf-title cf-title--4">
            •••• {{ card.cardNumberLastFour }}
          </h4>
        </div>

        <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-8">
          <p class="cf-subtitle cf-subtitle--3">
            Card Balance: {{ $dollars(card.amount) }}
          </p>
        </div>
      </label>
    </div>

    <slot name="below-listed-cards" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';

  import CfCardTypeIcon from '@/view/components/shared/cf-card-type-icon/index.vue';


  export default {
    name: 'CfSavedGiftCards',

    components: {
      CfCardTypeIcon
    },

    props: {
      paymentGateway: {
        type: Object,
        required: true
      },

      canApplyGiftCards: {
        type: Boolean,
        required: true
      },

      giftCards: {
        type: Array,
        required: true
      }
    },

    computed: {
      ...mapGetters('session', ['session']),
      ...mapGetters('content', ['content'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      async createdHandler() {
        if (this.session.isSignedIn) {
          try {
            await this.$store.dispatch('giftCards/getSavedCards', { allowCache: false });
          }
          catch (error) {
            errorHandlers.silent(error);
          }
        }
      },

      addNewGiftCardClickHandler() {
        this.$openModal('addGiftCard', { paymentGateway: this.paymentGateway });
      },

      inputHandler(giftCard) {
        const mutation = giftCard.isApplied
          ? 'giftCards/REMOVE_APPLIED_CARD_NUMBER'
          : 'giftCards/ADD_APPLIED_CARD_NUMBER';

        this.$store.commit(mutation, giftCard.cardNumber);
      }
    }
  };
</script>
